import React from 'react'

import { Form } from 'antd'

const { Item } = Form

const BroadcastHiddenForm: React.FC = () => {
	return (
		<div hidden>
			<Item name='template' />
			<Item name='templateReference' />
			<Item name='templatePreview' />
			<Item name='isTimeSensitive' />
			<Item name='audienceType' />
			<Item name='audienceTypeFilter' />
			<Item name='audience' />
			<Item name='contactFilter' />
			<Item name='contacts' />
			<Item name='parameters' />
			<Item name='headerParameter' />
			<Item name='urlParameter' />
			<Item name='templateParameter' />
			<Item name='templateHeaderParameter' />
			<Item name='templateUrlParameter' />
			<Item name='mediaSelectionType' />
			<Item name='staticAttachment' />
			<Item name='media_url' />
			<Item name='fileName' />
			<Item name='currentStep' />
			<Item name='scheduleDate' />
			<Item name='scheduleTime' />
			<Item name='time' />
			<Item name='autoAssignType' />
			<Item name='autoAssignTeam' />
			<Item name='autoAssignAgents' />
			<Item name='tags' />
			<Item name='enquiry' />
			<Item name='defaultMessage' />
			<Item name='shouldSchedule' />
			<Item name='qrBtnActionSetting' />
		</div>
	)
}

export default BroadcastHiddenForm
